module.exports = __webpack_public_path__ + "assets/img/sky.f80b32b6.jpg";